import { FC, useCallback, useEffect, useState } from "react";
import { VoidFunc } from "../../../helpers/functions/types";
import { SwitchableGroup } from "./general/SwitchableGroup";
import { FiltersSwitch } from "../../../components/Interaction/FiltersSwitch";

export const AttributeGroupWrapper: FC<{
  initAttributesGroup: string[];
  handleAttributesGroup: VoidFunc<string[]>;
  groupAttributesList: string[];
  attributeGroupTitle?: string;
  isNewPage?: boolean;
}> = ({
  initAttributesGroup,
  handleAttributesGroup,
  groupAttributesList,
  attributeGroupTitle,
  isNewPage,
}) => {
  const [attributesGroup, setAttributesGroup] = useState(initAttributesGroup);

  useEffect(() => {
    setAttributesGroup(initAttributesGroup);
  }, [initAttributesGroup]);

  const RenderSwitch = useCallback(
    (attr: string) => {
      const handleChange = (changedAttribute: string) => {
        const newAttributesGroup = attributesGroup.includes(changedAttribute)
          ? attributesGroup.filter((a) => a !== changedAttribute)
          : [...attributesGroup, changedAttribute];
        setAttributesGroup(newAttributesGroup);
        handleAttributesGroup(newAttributesGroup);
      };
      const isChecked = attributesGroup?.includes(attr) || false;
      return (
        <FiltersSwitch
          key={attr}
          title={attr}
          value={isChecked}
          onChange={() => handleChange(attr)}
        />
      );
    },
    [attributesGroup, handleAttributesGroup],
  );

  return (
    <SwitchableGroup title={attributeGroupTitle} isNewPage={isNewPage}>
      {groupAttributesList.map((attr) => RenderSwitch(attr))}
    </SwitchableGroup>
  );
};
